import { Dropdown, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FiCheck } from "react-icons/fi";
import { MdOutlineClose } from "react-icons/md";
import SessionUtil from "../util/SessionUtil";
import React from "react";

function Filter({
  handleClick,
  setShowOffcanvas,
  showOffcanvas,
  type,
  filter,
  country,
  data,
  stateId,
  stateName
}) {
  const { t } = useTranslation();
  const lang = SessionUtil.getLang();

  const handleToggle = (isOpen) => {
    if (!isOpen) {
      // القائمة أُغلقت
      document.body.classList.remove("bg-offcanvas");
      setShowOffcanvas(!showOffcanvas);
    }
  };
  const handleShowshowOffcanvas = () => {
    if (showOffcanvas) {
      document.body.classList.add("bg-offcanvas");
      setShowOffcanvas(false);
    } else {
      document.body.classList.remove("bg-offcanvas");
      setShowOffcanvas(true);
    }
  };
  return type === "country" ? (
    <Dropdown className="filter" autoClose="true" onToggle={handleToggle}>
      <Dropdown.Toggle
        aria-label="Aria Name"
        id="dropdown-autoclose-true"
        className="border-0"
      >
        <div className="flex-gap-2 p-2" onClick={handleShowshowOffcanvas}>
          <p className="mb-0">{country === '962' ? t("Jordan") : country === '1'? t("USA") : t("Country") }</p>
          <Image alt="image" src="/images/filter.png" />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="border-0 p-2">
        <Dropdown.Item
          className="status text-start"
          onClick={() => handleClick(filter, '1','country')}
        >
          {t("USA")}
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          className="status text-start"
          onClick={() => handleClick(filter, '962','country')}
        >
          {t("Jordan")}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  ) : type === "state" ? (
    <Dropdown className="filter" autoClose="true" onToggle={handleToggle}>
      <Dropdown.Toggle
        aria-label="Aria Name"
        id="dropdown-autoclose-true"
        className="border-0"
      >
        <div className="flex-gap-2 p-2" onClick={handleShowshowOffcanvas}>
          <p className="mb-0">{stateName ? stateName : t("State") }</p>
          <Image alt="image" src="/images/filter.png" />
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="border-0 p-2 dropdown-custome">
        {data.map((item, index) => (
          <React.Fragment key={index}>
            <Dropdown.Item
              className="status text-start"
              onClick={() => handleClick(filter,country,'', item.Id, lang === "en" ? item.NameEn : item.NameAr)}
            >
              {lang === "en" ? item.NameEn : item.NameAr}
            </Dropdown.Item>
            {index < data.length - 1 && <Dropdown.Divider />}
          </React.Fragment>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  ) : (
    <Dropdown className="filter" autoClose="true" onToggle={handleToggle}>
      <Dropdown.Toggle
        aria-label="Aria Name"
        id="dropdown-autoclose-true"
        className="border-0"
      >
        <div className="flex-gap-2 p-2" onClick={handleShowshowOffcanvas}>
          <p className="mb-0">{filter === 'PAID' ? t('Paid') : filter === 'NOT_PAID' ?t('Not Paid') : t("Filter")}</p>
          <Image alt="image" src="/images/filter.png" />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="border-0 p-2">
        <Dropdown.Item
          className="status status-success rounded flex-gap-2"
          onClick={() => handleClick("PAID", country, '',stateId)}
        >
          <FiCheck /> {t("Paid Status")}
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          className="status status-failed rounded flex-gap-2"
          onClick={() => handleClick("NOT_PAID", country, '',stateId)}
        >
          <MdOutlineClose />
          {t("Not Paid Status")}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default Filter;
